module.exports = __webpack_public_path__ + "static/media/addEvent.d6dc6df6.svg";